const loader = document.getElementById("spinner_custom");

// Function to hide the loader
function hideLoader() {
  loader.classList.remove("visible");
}

// Show loader when the page starts loading
window.addEventListener("beforeunload", () => {
  loader.classList.add("visible");
});

// Hide loader after page load completes
window.addEventListener("load", hideLoader);

// Hide loader after back/forward navigation (cache)
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    hideLoader();
  }
});

// Custom events for filter actions
document.addEventListener("filter-started", () => {
  loader.classList.add("visible");
});

document.addEventListener("filter-completed", hideLoader);